import { render } from "./RecipeGenerateList.vue?vue&type=template&id=12bca6e4&scoped=true"
import script from "./RecipeGenerateList.vue?vue&type=script&lang=js"
export * from "./RecipeGenerateList.vue?vue&type=script&lang=js"

import "./RecipeGenerateList.vue?vue&type=style&index=0&id=12bca6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bca6e4"]])

export default __exports__